// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import './assets/css/base.css'
import animated from 'animate.css'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import App from './App'
import router from './router'
import store from './store' // Vuex
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/iconfont.css'
import '@/assets/styles/index.scss' // global css
import locale from 'element-ui/lib/locale/lang/en'
// import request from './utils/request'
import moment from 'moment'
import Print from 'vue-print-nb'
// import axios from 'axios'
import http from './utils/axios'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import '@/assets/font/iconfont.css'
// import VueCropper from 'vue-cropper'
// import VueCropper from 'vue-cropperjs'

// require styles
import 'swiper/dist/css/swiper.css'
import { hasPerm } from './utils/hasPerm'
import Bus from './utils/eventBus'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
// import VueBMap from 'vue-bmap-gl'
// import 'vue-bmap-gl/dist/style.css'
// import VueMapvgl from 'vue-mapvgl'
// Vue.use(VueBMap)
// Vue.use(VueMapvgl)
// VueBMap.initBMapApiLoader({
//   ak: 'PBGIt6HA2VN8etXXgIySU4wzn0Nbs6f0',
//   v: '1.0'
// })
Vue.use(Viewer)
Vue.use(animated)
Viewer.setDefaults({
  toolbar: false,
  title: false,
  navbar: false
})
require('babel-polyfill')
Vue.use(VueAwesomeSwiper)
Vue.use(Print)
Vue.prototype.$http = http
Vue.prototype.hasPerm = hasPerm
Vue.prototype.Bus = Bus

// Vue.use(VueCropper)
// Vue.component(VueCropper)

Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp']
Vue.use(ElementUI, {
  size: 'medium', // set element-ui default size
  locale
})
Vue.filter('dateFormat', function (input, formatstring) {
  return moment(input).format(formatstring)
})

Vue.filter('decimalFormat', function (input, formatstring) {
  if (input !== undefined) {
    var options = {
      style: 'currency',
      currency: 'CNY'
    }
    return input.toLocaleString('zh-CN', options)
  }
  return input
})
// Vue.use(request)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js